/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

/** Access tiers based on GHOST token stake amount */
export enum AccessTier {
  None,
  Basic,
  Verified,
  Pro,
  Whale,
}

export type AccessTierArgs = AccessTier;

export function getAccessTierEncoder(): FixedSizeEncoder<AccessTierArgs> {
  return getEnumEncoder(AccessTier);
}

export function getAccessTierDecoder(): FixedSizeDecoder<AccessTier> {
  return getEnumDecoder(AccessTier);
}

export function getAccessTierCodec(): FixedSizeCodec<
  AccessTierArgs,
  AccessTier
> {
  return combineCodec(getAccessTierEncoder(), getAccessTierDecoder());
}
